module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiM1MEM3MTYiLz4KPHBhdGggZD0iTTQgOC40NjY2N0w3LjkgMTEuNUwxMi4yMzMzIDUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS43MzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/icons/verified.svg
// module id = 3195
// module chunks = 0